import { Icon } from './Icon'
import styles from './SearchInput.module.css'

interface SearchInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  width?: number | string
  'aria-label'?: string
}

export function SearchInput({
  value,
  onChange,
  placeholder,
  width = '100%',
  'aria-label': ariaLabel,
}: SearchInputProps) {
  return (
    <div className={styles.wrap} style={{ width }}>
      <Icon name="search" size={20} color="var(--color-text-secondary)" />
      <input
        type="search"
        className={styles.input}
        value={value}
        placeholder={placeholder}
        aria-label={ariaLabel ?? placeholder ?? 'Buscar'}
        onChange={(e) => onChange(e.target.value)}
      />
      {value && (
        <button
          type="button"
          className={styles.clear}
          aria-label="Limpar busca"
          onClick={() => onChange('')}
        >
          <Icon name="close" size={18} />
        </button>
      )}
    </div>
  )
}
